import React from 'react';

import {
  NormalizedSuccessStatus,
  SUCCESS_STATUS_DISPLAY,
} from '@/types/enhanced-bland-call';

interface CallEvaluationBadgeProps {
  successStatus: NormalizedSuccessStatus | undefined;
  size?: 'sm' | 'md';
}

export const CallEvaluationBadge: React.FC<CallEvaluationBadgeProps> = ({
  successStatus,
  size = 'md',
}) => {
  if (!successStatus) return null;

  const display = SUCCESS_STATUS_DISPLAY[successStatus];
  if (!display) return null;

  const sizeClasses =
    size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-1';

  return (
    <span className={`font-medium ${display.className} ${sizeClasses}`}>
      {display.label}
    </span>
  );
};
